import { Stepper } from '@app-velocity/ui'

export type AuthStepperProps = {
    step: 'finish';
}

export const AuthStepper = ({ step }: AuthStepperProps) => {
    return (
        <Stepper>
            <Stepper.Step status="finished" label="users:auth.account_information" />
            <Stepper.Step status={step === 'finish' ? 'active' : 'waiting'} label="users:auth.finish" />
        </Stepper>
    )
}